<template>
  <a :href="getUrl(post.slug)" class="h-full flex flex-col">
    <div class="aspect-w-1 aspect-h-1 bg-light-pink-two rounded-lg overflow-hidden">
      <img
        v-if="post.thumbnail"
        :srcset="`${post.thumbnail.urls.hero_mobile} 1x, ${post.thumbnail.urls.hero_mobile_2x} 2x`"
        :src="post.thumbnail.urls.hero_mobile"
        :alt="altText"
        class="full-bg-cover"
      />
    </div>
    <p class="flex-grow w-full p-5 text-center text-lg leading-7">{{ post.title }}</p>
    <hr class="mx-auto w-1/2 border-t-2 border-dark-peach">
  </a>
</template>

<script>
import Route from '../src/Route';
import get from 'lodash/get';

export default {
  props: {
    post: {
      required: true,
      type: Object,
    },
  },

  computed: {
    altText() {
      return get(this.post, 'thumbnail.alt_text');
    },
  },

  methods: {
    getUrl(slug) {
      return Route('posts.show', {post: slug});
    },
  },
}
</script>
